import {Message} from "element-ui";
import _request from "../common/_request";
import cache_activity from "../cache/cache_activity";


let lib_wx = {
    // 项目信息， ui
    parameter: function (callback) {
        let data = {};
        data.mini_id = 1;
        data.url = encodeURIComponent(window.location.href);
        // console.log(data, '入参')
        _request._get('/weixin/parameter', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            // cache_activity.set(response.data);
            callback(response.data)
        })
    },




};
export default lib_wx
